import { httpDelete, httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  CreatePreservationFn,
  DeletePreservationFn,
  GetPreservationsFn,
  UpdatePreservationFn,
} from "./preservations.types";

const getPreservations: GetPreservationsFn = async (query = {}) => {
  const { uuid, ...rest } = query;
  if (uuid) return httpGet(`/preservations/${uuid}`, rest);
  return httpGet("/preservations", rest);
};

const createPreservation: CreatePreservationFn = async (data) => {
  return httpPost("/preservations", data);
};

const updatePreservation: UpdatePreservationFn = async (data) => {
  const { uuid, ...rest } = data;
  return httpPatch(`/preservations/${uuid}`, rest);
};

const deletePreservation: DeletePreservationFn = async (data) => {
  const { uuid } = data;
  return httpDelete(`/preservations/${uuid}`);
};

export const PreservationsAPI = {
  get: getPreservations,
  create: createPreservation,
  update: updatePreservation,
  delete: deletePreservation,
};
